import preparedReducer from './reducer';
import {
  requestSites,
  requestAddSite,
  updateSite,
  updateSiteForms,
  requestSiteForms,
  requestVisitorLogSetting,
  updateVisitorLogSetting,
  requestVisitorLogSettings,
  requestSiteMobileSettings,
  updateSiteMobileSettings,
  requestSitesSupervisors,
  requestSiteUsers,
  updateSiteUsers,
  updateSiteMaxShiftHours,
  resetSitesMaxShiftHours,
  updateSiteScanType,
} from './actions';
import { createSelector } from 'reselect';
import { ENTITY_STATUS } from 'app/types/constants';

export const reducer = preparedReducer;

export const SLICE_NAME = 'sites';

export const selectors = (state) => state[SLICE_NAME];

export const selectVisitorLogSetting = (state, siteID) => state[SLICE_NAME].visitorLogSettings[siteID];

export const selectSitesSupervisors = (state) => state[SLICE_NAME].supervisors;

export const getActiveSitesSelect = createSelector(selectors, ({ list }) =>
  list
    .filter(({ status }) => status === ENTITY_STATUS.ACTIVE)
    .map(({ siteID, siteName }) => ({
      key: siteID,
      label: siteName,
    }))
);

const formatSiteAddress = (site) => {
  const line1 = (site?.addressLine1 || '').trim();
  const line2 = (site?.addressLine2 || '').trim();
  if (line1 && line2) return `${line1}, ${line2}`;
  return line1 || line2 || '';
};

export const getSiteCoordinatesByID = createSelector(selectors, ({ list }) => {
  const map = {};
  for (const site of list) {
    if (site?.siteID == null) continue;
    map[site.siteID] = {
      latitude: site.latitude,
      longitude: site.longitude,
      siteName: site.siteName,
      address: formatSiteAddress(site),
    };
  }
  return map;
});

export const actions = {
  requestSites,
  requestAddSite,
  updateSite,
  updateSiteForms,
  requestSiteForms,
  requestSiteUsers,
  updateSiteUsers,
  requestVisitorLogSetting,
  updateVisitorLogSetting,
  requestVisitorLogSettings,
  requestSiteMobileSettings,
  updateSiteMobileSettings,
  requestSitesSupervisors,
  updateSiteMaxShiftHours,
  resetSitesMaxShiftHours,
  updateSiteScanType,
};
